/**
 * @generated SignedSource<<8b26582819a0d938f6932347c0b48c7f>>
 * @relayHash a47f5cfa7055c553623204a7a8a085cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2fdc2ea007d95e40511649430accf7d9306f9e34d4b47e98c243a25774ece2de

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery } from './uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery.graphql';

const node: PreloadableConcreteRequest<uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2fdc2ea007d95e40511649430accf7d9306f9e34d4b47e98c243a25774ece2de",
    "metadata": {},
    "name": "uiGrowthJswUpsellModal_GetStartStandardTrialUrlQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
